import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, ShieldAlert } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { superadminApi } from '../lib/api';

// Persistent indicator shown whenever a superadmin is acting as a customer user
// (consent-login). Sits as a floating pill so it never hides the page header.
const ImpersonationBanner = () => {
  const { impersonation, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!impersonation) return null;

  const exit = async () => {
    const ticketId = impersonation.ticketId;
    stopImpersonation();                 // restores the superadmin token synchronously
    try { await superadminApi.impersonateEnd(ticketId); } catch (e) { /* best-effort */ }
    navigate('/superadmin');
  };

  return (
    <div className="fixed bottom-4 inset-x-0 z-[60] flex justify-center px-4 pointer-events-none">
      <div className="pointer-events-auto bg-red-600 text-white text-sm rounded-full shadow-lg px-4 py-2 flex items-center gap-3 max-w-full">
        <ShieldAlert className="w-4 h-4 shrink-0" />
        <span className="truncate">
          Support session — viewing as <strong>{impersonation.name}</strong>
          {impersonation.company ? ` · ${impersonation.company}` : ''}
        </span>
        <button
          onClick={exit}
          className="shrink-0 flex items-center gap-1 bg-white/20 hover:bg-white/30 rounded-full px-3 py-1 transition"
        >
          <LogOut className="w-3.5 h-3.5" /> Exit
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
